// @flow
import queryString from 'query-string';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import type { RouterHistory, Location } from 'react-router';
import type { Dispatch } from '../redux/main';
import { showModal } from '../redux/main/actions/modal';

type Props = {
  objectType: 'ORG' | 'GROUP',
  objectId: string,
  objectName: string,
  loggedIn: boolean,
  currentUser: Object,
  otherModalShown: boolean,
  isAdmin: boolean,
  history: RouterHistory,
  location: Location,
  showAdminRequestModal: () => void,
  showEmailSignupModal: () => void,
  render: ({ requestAdmin: () => void }) => React.Node,
  modal: Object
};

class AdminRequestContainer extends React.PureComponent<Props> {
  componentDidMount() {
    this.checkQueryParam();
  }

  componentDidUpdate() {
    this.checkQueryParam();
  }

  checkQueryParam() {
    const { modal } = this.props;
    if (!this.props.currentUser.isLoaded) {
      return;
    }
    const otherModalShown =
      modal && modal.type && modal.type !== 'ADMIN_REQUEST';

    const queryParams = queryString.parse(this.props.location.search);
    if (queryParams['admin-request'] === 'true' && !otherModalShown) {
      this.props.showAdminRequestModal();
      this.props.history.replace(this.props.location.pathname);
    }
  }

  render() {
    const {
      currentUser,
      render,
      loggedIn,
      showAdminRequestModal,
      showEmailSignupModal,
      objectId,
      objectType
    } = this.props;

    const isAdmin =
      objectType === 'ORG'
        ? currentUser.orgs && currentUser.orgs.find(org => org.id === objectId)
        : currentUser.groups &&
          currentUser.groups.find(group => group.id === objectId);

    return !currentUser.isLoaded || isAdmin
      ? null
      : render({
          requestAdmin: loggedIn ? showAdminRequestModal : showEmailSignupModal
        });
  }
}

const mapStateToProps = ({ currentUser, modal }, { objectType, objectId }) => ({
  currentUser,
  objectType,
  objectId,
  loggedIn: !!currentUser.id,
  modal
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  { objectType, objectId, objectName, location }
) => ({
  showAdminRequestModal: () => {
    dispatch(
      showModal('ADMIN_REQUEST', {
        objectType,
        objectId,
        objectName
      })
    );
  },
  showEmailSignupModal: () => {
    dispatch(
      showModal('EMAIL_SIGNUP', {
        title: /* TRANSLATORS: title of dialog to request to be admin of org or group */ getText(
          'Request to Become an Administrator'
        ),
        redirectTo: `${location.pathname}?admin-request=true`
      })
    );
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdminRequestContainer)
);
